import React from 'react';
import {ServiceBase} from "../ServiceBase";
import {INotificationsService} from "./notifications.service.interface";
import {action, makeObservable, observable} from "mobx";
import {
    SnackbarNotificationComponent
} from "../../components/notifications/snackbar-notification.component";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export interface SnackbarNotificationParams {
    text: string;
    ctaText: string;
    onCtaClick: () => void;
}

export interface DisplaySnackBarOptions extends SnackbarNotificationParams {
    displayTimeMs: number;
}

type ActiveNotification = {
    id: number;
    value: React.ReactNode;
}

export class NotificationsService extends ServiceBase implements INotificationsService {

    private static readonly SAVE_GAME_NOTIFICATION_DISPLAY_TIME_MS: number = 3000;

    constructor(services:IServiceFactoryExtended) {
        super(services);

        makeObservable(this);
    }

    @observable.ref
    private _currentNotifications: ActiveNotification[] = [];

    @action.bound
    private _setCurrentNotifications(newNotifications:  ActiveNotification[]): void {
        this._currentNotifications = newNotifications;
    }

    public get currentNotificationsComponents(): React.ReactNode[] {
        return this._currentNotifications.map(dialog => dialog.value);
    }

    public showGameSavedNotification(): void {
        this.showNotification({
            text: this.services.translation.translate("GAME_SAVED_NOTIFICATION_TEXT"),
            ctaText: this.services.translation.translate("GAME_SAVED_NOTIFICATION_CTA"),
            displayTimeMs: NotificationsService.SAVE_GAME_NOTIFICATION_DISPLAY_TIME_MS,
            onCtaClick: async () => {
                const userMenuService = await this.services.userMenu;
                userMenuService.openSaveGameWidget();
            }
        });
    }

    private showNotification(newNotificationOptions: DisplaySnackBarOptions) {
        const id: number = Date.now();
        setTimeout(() => this.removeNotification(id), newNotificationOptions.displayTimeMs);
        this._setCurrentNotifications([
            ...this._currentNotifications,
            {
                id: id,
                value: <SnackbarNotificationComponent
                    text={newNotificationOptions.text}
                    ctaText={newNotificationOptions.ctaText}
                    onCtaClick={newNotificationOptions.onCtaClick}
                />
            }
        ]);
    }

    private removeNotification(id: number): void {
        this._setCurrentNotifications(this._currentNotifications.filter(cn => cn.id !== id));
    }
}
